// extracted by mini-css-extract-plugin
export default {"box":"Categories_box__xzAC4","boxImage":"Categories_boxImage__1kNms","fakeImage":"Categories_fakeImage__YyOEM"};